import { poizonChannelID as poizon_channel_id } from '@/utils/urlUtils/getQuery'
export function createTrackConfig() {
  return {
    poizon_trade_product_purchase_remind_click(platform: string, dataset: any) {
      console.log('poizon_trade_product_purchase_remind_click dataset', dataset)
      const { record, pageTitle = '', tabItem, btnMsg, btnStatusMap } = dataset || {}
      if (!record || !tabItem) return
      if (btnMsg === btnStatusMap.remind || btnMsg === btnStatusMap.isSetting) {
        return {
          current_page: 82,
          block_type: 51,
          sku_id: record.skuId || '',
          venue_id: tabItem.venueId || '',
          venue_title: pageTitle || '',
          status: btnMsg === btnStatusMap.remind ? 1 : 0,
          poizon_venue_market_name: tabItem.title || '',
          poizon_channel_id,
          SK: window.dw.getSk(),
        }
      }
    },
    poizon_venue_component_content_click(platform: string, dataset: any) {
      console.log('poizon_venue_component_content_click dataset', dataset)
      const { record, pageTitle = '', tabItem, btnMsg, btnStatusMap, index = 0 } = dataset || {}
      if (!record || !tabItem) return
      if (btnMsg === btnStatusMap.goBuy) {
        const statusMap = {
          '1': '0',
          '2': '3',
          '3': '1',
          '4': '2',
        }
        return {
          current_page: 82,
          block_type: 415,
          venue_id: tabItem.venueId || '',
          venue_title: pageTitle || '',
          component_content_id: record.skuId || '',
          component_content_title: record.title || '',
          component_content_url: `/router/sell/productDetail?spuId=${record.skuId}`,
          component_content_position: index + 1,
          poizon_component_type: 'poizon-activity-spike',
          // @ts-ignore
          poizon_venue_market_status: statusMap[tabItem.status] || '',
          poizon_venue_market_name: tabItem.title || '',
          poizon_channel_id,
          SK: window.dw.getSk(),
        }
      }
    },
    poizon_venue_component_content_exposure(platform: string, dataset: any) {
      // console.log('poizon_venue_component_content_exposure dataset', dataset)
      const { record, pageTitle = '', tabItem, index = 0 } = dataset || {}
      if (!record || !tabItem) return
      const statusMap = {
        '1': '0',
        '2': '3',
        '3': '1',
        '4': '2',
      }
      return {
        current_page: 82,
        block_type: 415,
        venue_id: tabItem.venueId || '',
        venue_title: pageTitle || '',
        poizon_channel_id,
        component_content_info_list: JSON.stringify([
          {
            component_content_id: record.skuId,
            component_content_title: record.title,
            component_content_position: index + 1,
            component_content_url: `/router/sell/productDetail?spuId=${record.skuId}`,
            poizon_component_type: 'poizon-activity-spike',
          },
        ]),
        // @ts-ignore
        poizon_venue_market_status: statusMap[tabItem.status] || '',
        poizon_venue_market_name: tabItem.title || '',
        SK: window.dw.getSk(),
      }
    },
    // 499埋点上报
    poizon_common_exposure(platform: string, dataset: any) {
      console.log('poizon_common_exposure dataset', dataset)
      const { current_page, block_type, spu_id, venue_id, status, level_1_tab_title } =
        dataset || {}
      return {
        current_page,
        block_type,
        spu_id,
        venue_id,
        status,
        level_1_tab_title,
      }
    },
    poizon_common_click(platform: string, dataset: any) {
      console.log('poizon_common_click dataset', dataset)
      const { current_page, block_type, button_title } = dataset || {}
      return {
        current_page,
        block_type,
        button_title,
      }
    },
  } as any
}
